import { useEffect } from 'react';
import { useSubscription } from '@apollo/client';
import {
  CrewMember,
  CrewMemberDiscipline,
  CrewMemberList,
  CrewMemberSortByTerm,
  EmployeeUpdatedPayload,
  PersonaType,
  SearchCrewMemberInput,
} from '@bechtel/types';
import { SUBSCRIPTION_EMPLOYEEE_UPDATED, GET_CREW_MEMBERS_WITH_SUPERVISOR } from '@bechtel/client-gql';
import { useLocation } from 'react-router-dom';
import { includes } from 'lodash';
import { useLazyQuery } from '@apollo/client';
import { useAppUser } from '~/components/molecules/appuser';
import { CacheKeys } from '~/components/atoms/cache-keys';
import { ProjectAppTypes } from '~/types';
import { useEnvProvider } from '../use-env-provider';

export function useEmployeeSubscription() {
  const { data: updatedEmployeeData } = useSubscription<{
    employeeUpdated: [EmployeeUpdatedPayload];
  }>(SUBSCRIPTION_EMPLOYEEE_UPDATED);
  const { user } = useAppUser();
  const { envConfig } = useEnvProvider();
  const location = useLocation();
  const dashboardSelectedUser: CrewMember = JSON.parse(sessionStorage.getItem(CacheKeys.DashboardSelectedUser));
  const personas = [
    PersonaType.SUPERINTENDENT,
    PersonaType.GENERAL_FOREMAN,
    PersonaType.FOREMAN,
    PersonaType.FIELD_WELD_ENGINEER,
    PersonaType.ROD_ROOM_ATTENDANT,
  ];
  const isASAppType = envConfig?.appName === ProjectAppTypes?.AS;
  const [getWelders] = useLazyQuery<{ crewMembers: CrewMemberList }, { input: SearchCrewMemberInput }>(
    GET_CREW_MEMBERS_WITH_SUPERVISOR,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    }
  );

  const fetchWelders = () => {
    getWelders({
      variables: {
        input: {
          discipline: CrewMemberDiscipline.WELDING,
          sortBy: CrewMemberSortByTerm.WELDER_STENCIL,
        },
      },
    });
  };
  useEffect(() => {
    if (!updatedEmployeeData || !updatedEmployeeData?.employeeUpdated?.length) return;
    const pathName = location.pathname;
    if (isASAppType && pathName && (pathName === '/dashboard' || pathName.includes('/'))) {
      if (!(includes(personas, user?.crewMember?.persona) || includes(personas, dashboardSelectedUser?.persona)))
        return;
      fetchWelders();
    }
  }, [updatedEmployeeData]);
  return null;
}
